import React, { lazy, Suspense, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Grid,
  Stack,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tab,
  Tabs,
  useTheme, useMediaQuery,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Spinner from "../../components/common/Spinner";
import { useLocation, useNavigate } from "react-router-dom";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import GroupsIcon from "@mui/icons-material/Groups";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import AppHeader from "../LandingPage/AppHeader/AppHeader";
import LandingPageFooter from "../LandingPage/LandingPageFooter/FooterForLandingPage";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import DastakLogo from "../../images/ProgramBaskets/DastakLogo.png";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { message } from "antd";
import { useSelector } from "react-redux";  
import {fetchIsNecCouncilMember} from "../../utils/necMembership";

const AuthModal = lazy(() => import("../VM/LoginPage/AuthModal/AuthModal"));

const highlights = [
  {
    title: "Dastak Programs",
    description:
      "Dastak offers 10 thoughtfully designed programs to support the community by BJS.",
    icon: <Diversity3Icon />,
  },
  {
    title: "Chapter Participation",
    description:
      "Help chapters show interest and connect with the right program opportunities.",
    icon: <GroupsIcon />,
  },
  {
    title: "Visit Planning",
    description:
      "Maintain Sadhu/Sadhvi visit information so touch-points stay organized.",
    icon: <EventAvailableIcon />,
  },
];

const DastakConceptDocuments = [
  {
    name: "Dastak Concept Document",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783683837264-Dastak_Concept_Doc.pdf",
  },
  {
    name: "Dastak Program in Detail Document",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783683663665-Dastak_Programs_In_Detail_Document.pdf",
  },
  {
    name: "Dastak Showcasing Material & Guidelines",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783683706810-Dastak_Showcasing_Doc.pdf"
  },
  {
    name: "Dastak Appeal & Training Document",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684012544-Dastak_Appeal__Training_Document.pdf",
  },
  {
    name: "Dastak Online Orientation Document",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783683552772-Dastak_Online_Orientation_Document.pdf",
  },
  {
    name: "Dastak HO Unit Creation Document",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783683961929-Dastak_HO_Unit_Creation_Document.pdf",
  },
  {
    name: "Dastak Guidelines for Office Bearers",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783683881305-Dastak_Guideline_for_Office_Bearer_Document.pdf",
  },
  {
    name: "Dastak Chapter Creation Document",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684080322-Dastak_Chapter_Creation_Document.pdf",
  },
];

const DastakProgramsDocuments = [
  {
    name: "BJS Manthan",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684451912-BJS_Manthan_Document.pdf",
  },
  {
    name: "Marrenting",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684592102-Marenting_Document.pdf",
  },
  {
    name: "The Path Finder – Pre Marriage Counselling",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684341161-Pre_Marriage_Counselling_Document.pdf",
  },
  {
    name: "The Path Finder – Post Marriage Counselling",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684310534-Post_Marriage_Counselling_Document.pdf",
  },
  {
    name: "Biodata Bank",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684420906-Biodata_Document.pdf",
  },
  {
    name: "Mention KNOT",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684131107-Mention_Knot_Document_4.pdf",
  },
   {
    name: "Vivaah Verse Application",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684392189-Vivaah_Verse_Mobile_App_Concept_Doc.pdf",
  },
  {
    name: "Parinay Path",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684281709-Parinay_Path_Document.pdf",
  },
  {
    name: "Humsafar Dobara",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684491395-Humsafar_Dobara_Document.pdf",
  },
  {
    name: "Jain Parivarik Adalat",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684536686-Jain_Parivarik_Adalat_Document.pdf",
  },
];


const DastakNewConceptDocuments = [
   {
    name: "Dastak Concept Document",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1785320457909-1._Dastak_Concept_Document.pdf",
  },
  {
    name: "BJS Manthan",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1785320458785-2._BJS_Manthan_Concept_Document.pdf",
  },
  {
    name: "Vivaah Verse Application",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1785320460471-6._Vivaah_Verse_Mobile_App_Concept_Document.pdf",
  },
  {
    name: "Parinay Path",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1785320458949-3._Parinay_Path_Concept_Document.pdf",
  },
  {
    name: "Humsafar Dobara",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1785320460334-5._Humsafar_Dobara_Concept_Document.pdf",
  },
  {
    name: "Jain Parivarik Adalat",
    link: "https://vmsprojectdata.s3.amazonaws.com/public/documents/1783684536686-Jain_Parivarik_Adalat_Document.pdf",
  },
]


const quickActions = [
  {
    title: "Understanding Dastak Programs",
    // description: "Visit details form.",
    image: true,
    icon: "",
    path: ""
  },
  {
    title: "Sadhu/Sadhvi Visit",
    // description: "Visit details form.",
    icon: <EventAvailableIcon />,
    path: "/dastak/sadhuSadhviVisitForm",
  },
  {
    title: "Dastak Programs",
    // description: "Dastak form.",
    icon: <Diversity3Icon />,
    path: "/dastak/dastakForm",
  },
  {
    title: "Create Chapter",
    // description: "Chapter creation form.",
    icon: <AddBusinessIcon />,
    path: "/dastak/createNewDastakChapter",
  },
];

const DastakSystemInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDastakHomepage = location.pathname === "/dastak/homepage";
  const joinButtonRef = useRef(null);
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const [entryMode, setEntryMode] = useState("join");
  const [documentsModalOpen, setDocumentsModalOpen] = useState(false)
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [documentPreviewSrc, setDocumentPreviewSrc] = useState("");
  const [documentViewerLoading, setDocumentViewerLoading] = useState(false);
  const [loading, setLoading] = useState(false)
    const permissionsState = useSelector((state) => state.permissions);
  
  const [tabValue, setTabValue] = useState(0);
  const [isNecCouncilMember, setIsNecCouncilMember] = useState();
  const isSuperUserFromPermissions =
    Boolean(permissionsState?.permissions?.isSuperUser) ||
    Boolean(permissionsState?.permissions?.permissions?.["*"]?.["*"]?.["*"]);
  console.log("isSuperUserFromPermissions", isSuperUserFromPermissions);  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const loggedInUser = Boolean(localStorage.getItem('userId'))
  const isSuperAdmin = Boolean(localStorage.getItem('activeDesignationSlug') === "superuser")
  
  useEffect(() => {
    window.scrollTo({top:"0", behaviour:"smooth"})

    const fetchNecCouncilMembership = async () => {
    const isNecMember = await fetchIsNecCouncilMember();
      setIsNecCouncilMember(isNecMember);
    };
  fetchNecCouncilMembership()
  }, [])

  const handleJoinModalOpen = () => {
    setEntryMode("join");
    setJoinModalOpen(true);
  };


  const handleJoinModalClose = () => {
    setJoinModalOpen(false);
    setEntryMode("join");
  };

 

  const openPdfInNewTab = (url) => {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.target = "_blank";
    anchor.rel = "noopener noreferrer";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  };

  const handleView = async (doc) => {
    if (isMobile) {
      openPdfInNewTab(doc.link);
      return;
    }

    setDocumentsModalOpen(true);
    setSelectedDocument(doc);
    setDocumentViewerLoading(true);

    try {
      const response = await fetch(doc.link);

      if (!response.ok) {
        throw new Error("Failed to fetch PDF preview");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      setDocumentPreviewSrc(blobUrl);
    } catch (error) {
      console.error("PDF preview load failed:", error);
      setDocumentPreviewSrc(doc.link + "#toolbar=0&navpanes=0&scrollbar=0");
    }
  };

  const handleDownload = async (doc) => {
    try {
      setLoading(true)
      message.info("Download started")
      const response = await fetch(doc.link);

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${doc.name}.pdf`;

      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setLoading(false)
      console.error("Download failed:", err);
      message.error("Download failed:")
    } finally {
      setLoading(false)
      message.success("Download completed")
    }
  };

  const handleBack = () => {
    if (documentPreviewSrc.startsWith("blob:")) {
      window.URL.revokeObjectURL(documentPreviewSrc);
    }
    setSelectedDocument(null);
    setDocumentPreviewSrc("");
    setDocumentViewerLoading(false);
  };

  const handleDocumentsModalClose = () => {
    if (documentPreviewSrc.startsWith("blob:")) {
      window.URL.revokeObjectURL(documentPreviewSrc);
    }
    setDocumentsModalOpen(false);
    setSelectedDocument(null);
    setDocumentPreviewSrc("");
    setDocumentViewerLoading(false);
  };

  return (
    <>
      {!isDastakHomepage && <AppHeader />}
      <Spinner loading={loading} />
      <Box
        sx={{
          minHeight: "90vh",
          background: "#F8FAFC",
          px: { xs: 2, sm: 3, md: 1 },
          py: { xs: 3, md: 2 },
        }}
      >
        {(loggedInUser && isNecCouncilMember || isSuperAdmin) && <Button variant="outlined" startIcon={<ArrowBackIcon/>} onClick={() => navigate("/dashboard")}>
          
          VMS
        </Button>}
        <Box sx={{ maxWidth: 1200, mx: "auto" }}>
          <Stack spacing={1.5} sx={{ mb: 4, display: "flex", flexDirection: { xs: "column", md: "row" } }}>
            <Box component={"img"} src={DastakLogo} alt="Dastak Logo" sx={{ height: 180, width: 180, alignSelf: "center" }} />
            <Box>
              <Typography
                variant="h4"
                sx={{
                  color: "#111827",
                  fontWeight: 800,
                  fontSize: { xs: "1.12rem", md: "1.625rem" },
                }}
              >
                Dastak
              </Typography>
              <Typography
                sx={{
                  color: "#475569",
                  fontSize: { xs: "0.875rem", md: "1.05rem" },
                  lineHeight: 1.7,
                }}
              >
                Dastak is a thoughtfully designed basket of 10 programs dedicated to addressing some of the most significant challenges faced by the Jain community in the areas of marriage and married life. It serves as a supportive platform for individuals and families navigating concerns related to finding a suitable life partner, matrimonial compatibility, marital issues, remarriage, and related social challenges. Through guidance, counselling, and community-driven support, Dastak aims to provide meaningful solutions with sensitivity and care. By bringing together structured programs and compassionate assistance, it strives to build a more secure, informed, and supportive ecosystem for the Jain community.
              </Typography>
            </Box>
          </Stack>

          {isDastakHomepage && (
          
     <Grid container spacing={3} sx={{ mb: 4 }}>
  {quickActions.map((item) => {
    const isDastakProgram =
      item.title === "Understanding Dastak Programs";

    const isDisabled =
      !isDastakProgram && !isSuperUserFromPermissions;

    const handleQuickActionClick = () => {
      if (isDastakProgram) {
        setDocumentsModalOpen(true);
      } else if (item.path && !isDisabled) {
        navigate(item.path);
      }
    };

    return (
      <Grid item xs={12} sm={6} md={3} key={item.title}>
        <Card
          elevation={0}
          sx={{
            height: "100%",
            borderRadius: 3,
            border: "1px solid #CBD5E1",
            overflow: "hidden",
            opacity: isDisabled ? 0.55 : 1,
            filter: isDisabled ? "grayscale(100%)" : "none",
            transition: "all .2s ease",

            ...(!isDisabled && {
              "&:hover": {
                borderColor: "#2563EB",
                boxShadow: "0 10px 24px rgba(37,99,235,.12)",
                transform: "translateY(-2px)",
              },
            }),
          }}
        >
          <CardActionArea
            disabled={isDisabled}
            onClick={handleQuickActionClick}
            sx={{
              height: "100%",
              p: 2.5,
            }}
          >
            <Stack
              spacing={2}
              alignItems="center"
              justifyContent="center"
              sx={{ height: "100%" }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: 2,
                  bgcolor: "#EFF6FF",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {item.image ? (
                  <Box
                    component="img"
                    src={DastakLogo}
                    alt="Dastak"
                    sx={{
                      width: 42,
                      height: 42,
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  item.icon
                )}
              </Box>

              <Typography
                align="center"
                sx={{
                  fontWeight: 700,
                  fontSize: "1rem",
                  lineHeight: 1.4,
                }}
              >
                {item.title}
              </Typography>
            </Stack>
          </CardActionArea>
        </Card>
      </Grid>
    );
  })}
</Grid>
          )}

     
          {!isDastakHomepage && (
            <Box
              sx={{
                mt: 5,
                p: { xs: 3, md: 4 },
                border: "1px solid #CBD5E1",
                borderRadius: 2,
                background: "#FFFFFF",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "stretch", sm: "center" },
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Box>
                <Typography sx={{ fontWeight: 800, color: "#111827", mb: 0.75 }}>
                  View More Dastak Details
                </Typography>
                <Typography sx={{ color: "#64748B", lineHeight: 1.6 }}>
                  Login or register to continue with complete Dastak access.
                </Typography>
              </Box>
              <Button
                ref={joinButtonRef}
                onClick={handleJoinModalOpen}
                sx={{
                  alignSelf: { xs: "stretch", sm: "center" },
                  background: "linear-gradient(90deg, #7B2FF7, #9E4DFF)",
                  color: "#fff",
                  textTransform: "none",
                  fontSize: "14px",
                  fontWeight: 700,
                  px: 3,
                  height: 42,
                  borderRadius: "999px",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    opacity: 0.92,
                    background: "linear-gradient(90deg, #8C3BFF, #AE63FF)",
                  },
                }}
              >
                Login / Register
              </Button>
            </Box>
          )}
        </Box>
        {!isDastakHomepage && (
          <Suspense fallback={null}>
            <AuthModal
              open={joinModalOpen}
              onClose={handleJoinModalClose}
              anchorRef={joinButtonRef}
              entryMode={entryMode}
              clickedFromCTA
              centerOnPage
              postLoginRedirectRoute="/dastak/homepage"
            />
          </Suspense>
        )}

        <Dialog
          open={documentsModalOpen}
          onClose={handleDocumentsModalClose}
          fullWidth
          maxWidth="md"
          fullScreen={isMobile}
          PaperProps={{
            sx: {
              borderRadius: { xs: 0, sm: 2 },
              m: { xs: 0, sm: 2 },
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              alignItems: { xs: "flex-start", sm: "center" },
              justifyContent: "space-between",
              gap: 1.5,
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            {selectedDocument ? (
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{ width: "100%", justifyContent: "space-between" }}
              >
                <Button
                  startIcon={<ArrowBackIcon />}
                  onClick={handleBack}
                  size={isMobile ? "small" : "medium"}
                >
                  Back
                </Button>

                <Typography
                  fontWeight={700}
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    px: 1,
                    fontSize: { xs: "0.95rem", sm: "1rem" },
                  }}
                >
                  {selectedDocument.name}
                </Typography>

                <IconButton onClick={handleDocumentsModalClose}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            ) : (
              <>
                <Typography fontWeight={700} sx={{ fontSize: { xs: "1rem", sm: "1.15rem" } }}>
                  Understanding Dastak Programs
                </Typography>

                <IconButton onClick={handleDocumentsModalClose}>
                  <CloseIcon />
                </IconButton>
              </>
            )}
          </DialogTitle>

          <DialogContent sx={{ p: 0, height: "80vh" }}>
            {!selectedDocument ? (
              <>
                <Tabs
                  value={tabValue}
                  onChange={(e, value) => setTabValue(value)}
                  centered={!isMobile}
                  variant={isMobile ? "fullWidth" : "standard"}
                  scrollButtons={isMobile ? "auto" : false}
                  sx={{
                    borderBottom: "1px solid #E2E8F0",
                    minHeight: 48,
                  }}
                >
                  {/* <Tab label={"Dastak Program Documents (" + DastakConceptDocuments.length + ")"} />

                  <Tab label={"Program Concept Documents (" + DastakProgramsDocuments.length + ")"} /> */}

                  <Tab label={"Dastak Concept Documents (" + DastakNewConceptDocuments.length + ")"} />
                </Tabs>

                <Box sx={{ p: { xs: 1.5, sm: 2 } }}>
                  {
                  // (tabValue === 0
                  //   ? DastakConceptDocuments
                  //   : DastakProgramsDocuments
                  // )
                  DastakNewConceptDocuments.map((doc, index) => (
                    <Paper
                      key={index}
                      elevation={0}
                      sx={{
                        display: { xs: "block", sm: "none" },
                        mb: 1.25,
                        border: "1px solid #E2E8F0",
                        borderRadius: 2,
                        p: 1.5,
                      }}
                    >
                      <Stack spacing={1.25}>
                        <Typography sx={{ fontWeight: 700, color: "#111827" }}>
                          {doc.name}
                        </Typography>

                        <Stack direction="row" spacing={1}>
                          <Button
                            fullWidth
                            variant="outlined"
                            startIcon={<VisibilityIcon />}
                            onClick={() => handleView(doc)}
                            sx={{ textTransform: "none" }}
                          >
                            View
                          </Button>
                          <Button
                            fullWidth
                            variant="contained"
                            startIcon={<DownloadIcon />}
                            onClick={() => handleDownload(doc)}
                            sx={{ textTransform: "none" }}
                          >
                            Download
                          </Button>
                        </Stack>
                      </Stack>
                    </Paper>
                  ))}

                  <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                      display: { xs: "none", sm: "block" },
                      border: "1px solid #E2E8F0",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ width: "70%", fontWeight: 700 }}>
                            Document Name
                          </TableCell>

                          <TableCell align="center" sx={{ width: { xs: "8%", sm: "12%", md: "15%" } }}>
                            View
                          </TableCell>

                          <TableCell align="center" sx={{ width: { xs: "8%", sm: "12%", md: "15%" } }}>
                            Download
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {
                        // (tabValue === 0
                        //   ? DastakConceptDocuments
                        //   : DastakProgramsDocuments
                        // )
                        DastakNewConceptDocuments.map((doc, index) => (
                          <TableRow key={index} hover>
                            <TableCell>{doc.name}</TableCell>

                            <TableCell align="center">
                              <IconButton onClick={() => handleView(doc)}>
                                <VisibilityIcon />
                              </IconButton>
                            </TableCell>

                            <TableCell align="center">
                              <IconButton onClick={() => handleDownload(doc)}>
                                <DownloadIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </>
            ) : (
              <Box
                sx={{
                  position: "relative",
                  height: { xs: "calc(100vh - 140px)", sm: "80vh" },
                  bgcolor: "#0F172A",
                }}
              >
                {documentPreviewSrc ? (
                  <iframe
                    src={documentPreviewSrc}
                    title={selectedDocument.name}
                    width="100%"
                    height="100%"
                    onLoad={() => setDocumentViewerLoading(false)}
                    style={{
                      border: "none",
                      display: "block",
                      background: "#fff",
                    }}
                  />
                ) : null}

                {documentViewerLoading && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      gap: 2,
                      bgcolor: "rgba(15, 23, 42, 0.72)",
                      color: "#fff",
                    }}
                  >
                    <CircularProgress color="inherit" />
                    <Typography sx={{ fontWeight: 600 }}>
                      Preparing PDF preview...
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </Box>
      {!isDastakHomepage && <LandingPageFooter />}
    </>
  );
};

export default DastakSystemInfo;
